import { joinUrl } from '@zurich-framework/core/utils';
import { useBaseConfig } from '../contexts';
/**
 * Gives quick access to the configured basePath of an application.
 *
 * Use-cases:
 * * to use basePath directly
 * * to prefix an url path with the base path
 */
export function useBasePath() {
    const { basePath } = useBaseConfig();
    return {
        basePath,
        withBasePath: (urlPath) => joinUrl(basePath, urlPath),
    };
}
